import { render, staticRenderFns } from "./AllSeller.vue?vue&type=template&id=58f89a2c&scoped=true&"
import script from "./AllSeller.vue?vue&type=script&lang=js&"
export * from "./AllSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f89a2c",
  null
  
)

export default component.exports